module.exports = __webpack_public_path__ + "static/media/metodos-de-pago.710e210d.png";